import allMatches from "../darts-results.json";

// Every player name that appears in the historical results dataset — the
// pool a player (or admin) searches to link an account to its match history.
export var allPlayerNames = Array.from(
  new Set(allMatches.flatMap(function(m) { return [m.player1, m.player2]; }))
).sort();
